module.exports = __webpack_public_path__ + "assets/img/wifiIcon-gray.a2e093b3.svg";